module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/book-details/book_detail_10-cf27b0a8cd04c3d7813e21d31de51b59.png";